import React from 'react';
import { amenities } from '../data/mock';
import { Waves, Dumbbell, ShoppingBag, Car, Baby, Shield, ArrowUpDown, Coffee, Tent } from 'lucide-react';

const iconMap = {
  Waves: Waves,
  Dumbbell: Dumbbell,
  ShoppingBag: ShoppingBag,
  Car: Car,
  Baby: Baby,
  Shield: Shield,
  ArrowUpDown: ArrowUpDown,
  Coffee: Coffee,
  Tent: Tent
};

const AmenitiesSection = () => {
  return (
    <section id="amenities" className="py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-amber-400 font-semibold tracking-wider uppercase text-sm">
            Lifestyle
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-white font-medium mt-4 mb-6">
            World-Class Amenities
          </h2>
          <p className="text-slate-400 text-lg">
            Enjoy a lifestyle of convenience and luxury with our comprehensive 
            range of premium amenities.
          </p>
        </div>

        {/* Amenities Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {amenities.map((amenity) => {
            const IconComponent = iconMap[amenity.icon];
            return (
              <div
                key={amenity.id}
                className="group bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-all duration-300"
              >
                <div className="w-12 h-12 bg-amber-500/20 rounded-xl flex items-center justify-center mb-5 group-hover:bg-amber-500 transition-colors duration-300">
                  {IconComponent && (
                    <IconComponent className="w-6 h-6 text-amber-400 group-hover:text-white transition-colors duration-300" />
                  )}
                </div>
                <h3 className="font-medium text-lg text-white mb-2">
                  {amenity.name}
                </h3>
                <p className="text-slate-400 text-sm leading-relaxed">
                  {amenity.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AmenitiesSection;
